// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"91c01106","513":"41657bab","703":"03d5fe17"}[chunkId] + ".chunk.js";
};